/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import NewTable from '../../components/NewTable/NewTable';

const SupplyMinedPKRD = () => {
  const [swap, setSwap] = useState([]);
  const [fees, setFees] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState('');
  const [feesClicked, setFeesClicked] = useState(false);


  const dummySwapData = [
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },

  ];

  const feesData = [
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },
    {
      total: "200,000,00,000.000",
      released: "100,000,000.000",
      inUse: "56,000,000.000",
      redeem: '40,000,000.00',
      date: "12/12/2025",
    },

  ];


  useEffect(() => {
    setSwap(dummySwapData);
  }, []);


  useEffect(() => {
    setFees(feesData);
  }, []);


  const tableHeadings = ['Total', 'Released', 'In Use', 'Redeem', 'Date'];
  const tableRows = swap?.map((ele, index) => [
    ele?.total,
    ele?.released,
    ele?.inUse,
    ele?.redeem,
    ele?.date,
  ]);

  const tableHeadingsFees = ['Network Fees', 'Knowledge Fees', 'Innovation Fees', 'Merchant', 'Date'];
  const tableRowsFees = fees?.map((ele, index) => [
    ele?.total,
    ele?.released,
    ele?.inUse,
    ele?.redeem,
    ele?.date,
  ]); 

  const onFeesClick = () => {
    setFeesClicked(!feesClicked);
    if (!feesClicked) {
      const updatedSwapData = swap.map(item => ({
        ...item,
        total: `${item.total} (${(parseFloat(item.redeem) / parseFloat(item.total) * 100).toFixed(4)}%)`,
      }));
      setSwap(updatedSwapData);
    } else {
      setSwap(dummySwapData);
    }
  };


  return (
    <div className='p-4 overflow-auto overflow-y-auto'>
      {feesClicked ?
        <NewTable
          Heading="Supply / Mined (PKRD)"
          tableHeadings={tableHeadingsFees}
          data={tableRowsFees}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          showSearch={true}
          placeholder="Search by name, email, phone or ID..."
          showSorting={true}
          fromDate={fromDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          toDate={toDate}
          showDateFilter={false}
          showPageTopData2={false}
          showPageTopData1={false}
          showPageTopData3={false}
          showPageTopData4={false}
          showFeesButton={true}
          onFeesClick={onFeesClick}
          feesClicked={feesClicked}
        /> :
        <NewTable
          Heading="Supply / Mined (PKRD)"
          tableHeadings={tableHeadings}
          data={tableRows}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          showSearch={true}
          placeholder="Search by name, email, phone or ID..."
          showSorting={true}
          fromDate={fromDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          toDate={toDate}
          showDateFilter={true}
          showPageTopData2={false}
          showPageTopData1={false}
          showPageTopData3={false}
          showPageTopData4={false}
          showFeesButton={true}
          onFeesClick={onFeesClick}
          feesClicked={feesClicked}
        />
      }
    </div>
  );
};

export default SupplyMinedPKRD;

